var _g, _g2, _path, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_704_3799)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.843,
    cy: 61.1172,
    r: 19.6384,
    fill: "#DF91F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bdi_704_3799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8311 37.1459C79.9699 30.2847 68.8497 30.2847 61.9885 37.1459C55.1273 30.2847 44.0071 30.2847 37.1459 37.1459C30.2847 44.0071 30.2847 55.1273 37.1459 61.9885L61.9885 86.8311L86.8311 61.9885C93.6923 55.1273 93.6923 44.003 86.8311 37.1459Z",
    fill: "#262626",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8311 37.1459C79.9699 30.2847 68.8497 30.2847 61.9885 37.1459C55.1273 30.2847 44.0071 30.2847 37.1459 37.1459C30.2847 44.0071 30.2847 55.1273 37.1459 61.9885L61.9885 86.8311L86.8311 61.9885C93.6923 55.1273 93.6923 44.003 86.8311 37.1459Z",
    fill: "black",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6062 37.5223C71.4435 37.5223 68.4691 38.7538 66.2353 40.9918L62.1848 45.0422L58.1344 40.9918C55.9006 38.7538 52.9262 37.5223 49.7635 37.5223C46.6009 37.5223 43.6265 38.7538 41.3927 40.9918C36.7776 45.6068 36.7776 53.1185 41.3927 57.7335L62.1848 78.5257L82.977 57.7335C87.5921 53.1185 87.5921 45.6068 82.977 40.9918C80.7432 38.7538 77.7688 37.5223 74.6062 37.5223Z",
    fill: "url(#paint0_linear_704_3799)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdi_704_3799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0704 37.3505C68.9315 30.4893 80.0518 30.4893 86.913 37.3505C93.7741 44.2116 93.7741 55.3319 86.913 62.1931L62.0704 87.0357V37.3505Z",
    fill: "#262626",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0704 37.3505C68.9315 30.4893 80.0518 30.4893 86.913 37.3505C93.7741 44.2116 93.7741 55.3319 86.913 62.1931L62.0704 87.0357V37.3505Z",
    fill: "black",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_704_3799",
    x: 0.291206,
    y: 0.565414,
    width: 121.104,
    height: 121.104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.4567,
    result: "effect1_foregroundBlur_704_3799"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_704_3799",
    x: 21.7717,
    y: 21.7717,
    width: 80.4336,
    height: 75.2878,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.11417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_704_3799"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.53296
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.41758
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_704_3799",
    result: "effect2_dropShadow_704_3799"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_704_3799",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.325556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976668
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_704_3799"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_704_3799",
    x: 51.842,
    y: 21.9762,
    width: 50.4452,
    height: 75.2878,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.11417
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_704_3799"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.53296
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.41758
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_704_3799",
    result: "effect2_dropShadow_704_3799"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_704_3799",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.325556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.976668
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_704_3799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_3799",
    x1: 37.9314,
    y1: 59.9837,
    x2: 86.4383,
    y2: 59.9837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEED7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF91FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartDark);
export default __webpack_public_path__ + "static/media/heart-dark.36dc2083e36673d79ef81cacdf6fe3db.svg";
export { ForwardRef as ReactComponent };